// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__Zm1uE","switch__signin":"Switch_switch__signin__tIUSg","paragraph":"Switch_paragraph__JqrpZ","switch__signup":"Switch_switch__signup__rSeEW"};